import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { BrandModel, HxBrandService } from 'hx-services';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzOptionComponent, NzSelectComponent, NzSelectModeType } from 'ng-zorro-antd/select';
import { NgFor } from '@angular/common';

@Component({
    selector: 'hx-brand-select',
    templateUrl: './brand-select.component.html',
    styleUrls: ['./brand-select.component.css'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => HxBrandSelectComponent),
            multi: true
        }],
  imports: [NzSelectComponent, FormsModule, NgFor, NzOptionComponent]
})
export class HxBrandSelectComponent implements OnInit, ControlValueAccessor {

  @Input() hxMode: NzSelectModeType = 'default';
  @Output() selectChange = new EventEmitter<BrandModel | BrandModel[] | undefined>();

  disabled = false;
  options: BrandModel[] = [];
  selected: number | number[] | undefined;

  constructor(
    private brandService: HxBrandService,
  ) {
  }

  async ngOnInit(): Promise<void> {
    const brands = await this.brandService.getBrands({limit: 1000});
    this.options = brands.list;
  }

  onModelChanged(val: any) {
    this.onChange(val);
    if (this.hxMode === 'default') {
      if (this.selected) {
        this.selectChange.emit(this.options.find(p => p.id === this.selected));
      } else {
        this.selectChange.emit();
      }
    } else {
      if (Array.isArray(this.selected)) {
        const ids: number[] = this.selected;
        this.selectChange.emit(this.options.filter(p => ids.includes(p.id)));
      } else {
        this.selectChange.emit([]);
      }
    }
  }

  onChange(val: any) {
    // console.log('onChange called', val);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj?: number | number[]): void {
    this.selected = obj;
  }
}
